import { TranslatePipe } from "@ngx-translate/core";

import { ChangeDetectionStrategy, Component, computed, input } from "@angular/core";

import { L3vpnSubscriptionDetails } from "../../../../../pages/subscription-detail/types";
import { InterconnectSummary } from "../../../interconnect-summary/interconnect-summary";

type L3vpnFirewallInterconnect = L3vpnSubscriptionDetails["firewallInterconnects"][number];

@Component({
  selector: "l3vpn-firewall-interconnect-panel",
  templateUrl: "l3vpn-firewall-interconnect-panel.html",
  host: { style: "display: contents" },
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [InterconnectSummary, TranslatePipe],
})
export class L3vpnFirewallInterconnectPanel {
  interconnect = input.required<L3vpnFirewallInterconnect>();

  protected subscriptionInstanceId = computed(() => this.interconnect().subscriptionInstanceId);
  protected availabilityZone = computed(() => this.interconnect().availabilityZone);
  protected firewallAsn = computed(() => this.interconnect().firewallAsn);
  protected ipv4Prefix = computed(() => this.interconnect().ipv4Prefix);
  protected ipv4AddressFirewall = computed(() => this.interconnect().ipv4AddressFirewall);
  protected ipv4Mtu = computed(() => this.interconnect().ipv4Mtu);
  protected ipv4MaxPrefix = computed(() => this.interconnect().ipv4MaxPrefix);
  protected ipv6Prefix = computed(() => this.interconnect().ipv6Prefix);
  protected ipv6AddressFirewall = computed(() => this.interconnect().ipv6AddressFirewall);
  protected ipv6Mtu = computed(() => this.interconnect().ipv6Mtu);
  protected ipv6MaxPrefix = computed(() => this.interconnect().ipv6MaxPrefix);

  protected service = computed(() => ({
    ...this.interconnect(),
    subscriptionId: this.interconnect().firewallSubscriptionId,
    product: { type: "FW", tag: "FW" },
    l3Endpoints: this.interconnect().saps,
  }));
}
